import type {
    CashRegisterConfig,
    CashRegisterSimpleConfig,
    CommonConfig,
    DepartmentConfig,
    DeviceConfig,
    MerchantConfig,
    MerchantDepartmentConfig,
    PaymentProviderConfig,
} from "./types";

// COMMON
export const commonConfigDefault: Readonly<CommonConfig> = {
    welcomeMessage: "",
    printOrderWhenCompleted: false,
    logOutWhenCompleted: "no",
    language: "da",
    miscButtons: null,
    buttonLayout: null,
    paymentOptions: null,
    tableLayout: null,
    rotation: "0",
    autoDeleteOrderIdleTimeout: 0,
    autoDeleteOrderWarningTimeout: 0,
    warnOnRefundAndReturn: true,
    queryCustomersForData: false,
    enableLayoutSwipe: false,
    printReceiptNumberOnOrderSummary: false,
    autoLogoutIdleTimeout: 0,
    autoLogoutWarningTimeout: 0,
};

export const paymentProviderConfigDefault: Readonly<PaymentProviderConfig> = {
    sumupAffiliateKey: "",
    sumupClientId: "",
    sumupClientSecret: "",
    sumupRefreshToken: "",
    sumupRedirectUrl: "",
    softpayIntegratorId: "",
    softpayMerchantReference: "",
    adyenTerminalApiKey: "",
    adyenKeyPassphrase: "",
    adyenKeyIdentifier: "",
    adyenKeyVersion: 1,
    adyenCryptoVersion: 1,
    adyenAccountHolderId: "",
    adyenStoreId: "",
};

export const cashRegisterPaymentProviderConfigDefault: Readonly<CashRegisterSimpleConfig> =
    {
        adyenTerminalApiPoiId: "",
        softpayCloudTerminalAppId: "",
    };

// MERCHANT & DEPARTMENT
export const merchantDepartmentConfig: Readonly<MerchantDepartmentConfig> = {
    address: "",
    zipcode: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    cvr: "",
    headerText: "",
    footerText: "",
    showServedBy: false,
    // showLogoOnReceipt: false,
    ...paymentProviderConfigDefault,
};

// MERCHANT
export const merchantConfigDefault: Readonly<MerchantConfig> = {
    ...commonConfigDefault,
    ...merchantDepartmentConfig,
    currency: "DKK",
    defaultVat: null,
    defaultDepartment: null,
    giftcardVatBookkeepingMethod: "AT_ISSUE",
    barcodeOnReceipt: true,
    headerOnPaymentReceipt: true,
    showServedBy: false,
    // showLogoOnReceipt: false,
    showDestinationOnShift: false,
};

// DEPARTMENT
export const departmentConfigDefault: Readonly<DepartmentConfig> = {
    ...commonConfigDefault,
    ...merchantDepartmentConfig,
};

// CASH REGISTER
export const cashRegisterConfigDefault: Readonly<CashRegisterConfig> = {
    receiptPrinter: null,
    ticketPrinter: null,
    showServedBy: false,
    // showLogoOnReceipt: false,
    startShiftCashAmount: 0,
    startShiftWithLastCashAmount: false,
    ...commonConfigDefault,
    ...cashRegisterPaymentProviderConfigDefault,
};

// DEVICE
export const deviceConfigDefault: Readonly<DeviceConfig> = {
    ...merchantConfigDefault,
    ...departmentConfigDefault,
    ...cashRegisterConfigDefault,
    ...cashRegisterPaymentProviderConfigDefault,
};
